// filters.js
import dayjs from "dayjs";
/** yyyy-MM-dd HH:mm:ss */
export function formatTimestamp(value) {
  if (!value) return '';
  return dayjs(value).format('YYYY-MM-DD HH:mm:ss');
}

export function datetime(value) {
  return formatTimestamp(value);
}

/** yyyy-MM-dd\nHH:mm:ss */
export function formatTimestampWithNewline(value) {
  if (!value) return '';
  return dayjs(value).format('YYYY-MM-DD\nHH:mm:ss');
}

// yyyy-MM-dd
export function formatDate(value) {
  if (!value) return '';
  return dayjs(value).format('YYYY-MM-DD');
}

export default {
  formatTimestamp,
  datetime,
  formatTimestampWithNewline,
  formatDate,
};
